var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcHeart = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8969 1.76696C10.6421 1.51205 10.3396 1.30983 10.0066 1.17187C9.67366 1.0339 9.31677 0.962891 8.95635 0.962891C8.59594 0.962891 8.23905 1.0339 7.90608 1.17187C7.57312 1.30983 7.27059 1.51205 7.0158 1.76696L6.48701 2.29575L5.95822 1.76696C5.44356 1.25229 4.74552 0.963157 4.01767 0.963157C3.28982 0.963157 2.59179 1.25229 2.07712 1.76696C1.56245 2.28163 1.27332 2.97966 1.27332 3.70751C1.27332 4.43536 1.56245 5.1334 2.07712 5.64807L2.60591 6.17685L6.48701 10.058L10.3681 6.17685L10.8969 5.64807C11.1518 5.39327 11.354 5.09075 11.492 4.75778C11.63 4.42482 11.701 4.06793 11.701 3.70751C11.701 3.3471 11.63 2.99021 11.492 2.65724C11.354 2.32428 11.1518 2.02175 10.8969 1.76696V1.76696Z",
    stroke: "white",
    strokeWidth: 1.06898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcHeart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-heart.d0692e81.svg";
export { ForwardRef as ReactComponent };